export default __webpack_public_path__ + "static/knowledge-7b62a296923cbaf4cbe784552186079d.png";